module.exports = __webpack_public_path__ + "static/img/ic_minus.743bd01a.svg";